module.exports = __webpack_public_path__ + "img/popcorn.834890d4.svg";